// TODO: add flow types

import spaCategories from './factories/spaCategories';

export default spaCategories('sport', 'Fitness', 'fitness');
